import type { UserDto } from "../UserDto";

interface UserFeedbackDto {
  feedbackGuid: string;
  title: string;
  type: UserFeedbackType;
  isDraft: boolean;
  isReviewedByRecipient: boolean;
  isReviewedInOneOnOne: boolean;
  givenByUser: Partial<UserDto>;
  submittedDateTimeUtc: string;
  createdDateTimeUtc: string;
}

enum UserFeedbackType {
  Performance = 1,
  Peer = 2,
  SelfReflection = 3,
}

export { UserFeedbackType, type UserFeedbackDto };
